// extracted by mini-css-extract-plugin
export default {"auth":"styles_auth__5VCzf","form":"styles_form__VVBuP","logo":"styles_logo__Eni0d","logoImage":"styles_logoImage__xEYWq"};